<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4zskAv/tc-custom/9781504046480.jpg?1734279930956" alt="This image is the cover for the book Bone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bone
      </h1>
      <p class="bookDescription body article font2">
        <b>In New York City, a homeless man with amnesia must unravel his past while a serial killer stalks the streets, in this taut thriller from the author of the Mongo Mysteries.</b><br/>  <br/> When he wakes up he remembers nothing, not even his own name. He doesn’t know why he’s squatting in Central Park or why he carries the human femur that earned him the nickname “Bone.” He has no idea what he’s done over the past year wandering the streets of Manhattan—or what came before.<br/>  <br/> Det. Lt. Perry Lightning suspects that Bone is the serial killer who’s been brutalizing the city’s homeless population. He also suspects Bone is playing games, pretending to have no knowledge of his life or his actions. But despite what the detective thinks, Bone doesn’t remember committing those horrific crimes.<br/>  <br/> With the help of a social worker named Anne and a street performer named Zulu, Bone attempts to discover the truth. But his pursuit of the past is about to take them deep into New York’s underground . . . where untold horrors await.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George C. Chesbro
      </h2>
      
      <p class="authorDescription body article">George C. Chesbro (1940&ndash;2008) was the author of twenty-eight books, including the renowned Mongo Mysteries, starring private eye Dr. Robert Frederickson, aka Mongo the Magnificent. He also wrote the Chant Mysteries and the Veil Kendry series, both featuring characters from the Mongo universe, as well as a few standalone novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0eaccd7e